import { FC, memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Card, Space, Tabs } from 'antd';
import { useQuery } from '@apollo/client';
import { GET_APPOINTMENTS } from 'gql/appointments/queries';
import { Appointments as AppointmentsType } from 'gql/appointments/__generated__/Appointments';
import { APPOINTMENT_VIEW_DASHBOARD } from 'constants/appointments';
import { CalendarOutlined, FormOutlined } from '@ant-design/icons';

import { Loading } from 'components/ui';
import { groupByStatus } from 'utils/appointments';
import TabItem from '../TabItem';

const Appointments: FC = () => {
  const { t } = useTranslation();

  const { data, loading } = useQuery<AppointmentsType>(GET_APPOINTMENTS, {
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
    variables: {
      query: {
        name: '',
        plan_type: '',
        pagination: {
          page: 0,
          limit: 999
        }
      }
    }
  });

  const appointments = data?.appointmentsForDoctor.data.results || [];
  const appointmentsSection = groupByStatus(appointments, 'status');

  if (loading) {
    return <Loading />;
  }

  return (
    <Card style={{ minHeight: 335 }}>
      <Tabs
        items={Object.keys(APPOINTMENT_VIEW_DASHBOARD).map(item => ({
          label: (
            <Space size={12}>
              {item === '1' ? <FormOutlined /> : <CalendarOutlined />}
              <span style={{ fontSize: 20 }}>
                {t(`dashboard.${APPOINTMENT_VIEW_DASHBOARD[item]}`)}
              </span>
            </Space>
          ),
          key: item,
          children: <TabItem data={appointmentsSection[item]} />
        }))}
      />
    </Card>
  );
};

export default memo(Appointments);
